import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux'
import { Switch , Route } from 'react-router-dom';
import { ConnectedRouter } from 'react-router-redux';
import store, { history } from './store';
import './index.css';

import registerServiceWorker from './registerServiceWorker';
import Home from './containers/home';
import Module from './containers/module';


const target = document.getElementById('root');

render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <div>
        <main>
          <Switch>
            <Route path="/module" component={Module} />
            <Route path="/" component={Home} />
          </Switch>
        </main>
      </div>
    </ConnectedRouter>
  </Provider>,
  target
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js